import React from 'react'
import { Redirect } from 'react-router-dom'

import { routes, IndexLayoutExtraProps } from '@sketch/modules-common'
import { LoadingState } from '@sketch/components'
import { useSocialSuccessfulSignIn } from './useSocialSuccessfulSignIn'

export interface SocialSuccessfulSignInViewProps
  extends IndexLayoutExtraProps {}

const SocialSuccessfulSignInView = (props: SocialSuccessfulSignInViewProps) => {
  const { state } = useSocialSuccessfulSignIn()

  switch (state.type) {
    case 'loading':
      return <LoadingState />
    case 'success':
      return <Redirect to={state.from ?? routes.ENTRY.create({})} />
    case 'success-delete-account':
      return <Redirect to={routes.SIGN_OUT.create({})} />
    case 'error':
      return <Redirect to={routes.SIGN_IN.create({})} />
  }
}

export default SocialSuccessfulSignInView
